import { ALERTS_URL } from 'features/alerts/paths'
import { ASK_YOGI_URL } from 'features/ask-yogi/paths'
import { CATALOG_URL } from 'features/catalog/paths'
import { CHARTS_2_URL } from 'features/charts-v2/paths'
import { CHARTS_URL } from 'features/charts/paths'
import { COVERAGE_URL } from 'features/coverage/paths'
import { DASHBOARD_URL } from 'features/dashboard/paths'
import { FEEDBACK_URL } from 'features/feedback/paths'
import { KEYWORDS_URL } from 'features/keywords/paths'
import { PDP_URL } from 'features/pdp/paths'
import { PRODUCT_WATCH_URL } from 'features/product-watch/paths'
import { RECOMMENDATIONS_URL } from 'features/recommendations/paths'
import { SAVED_VIEWS_URL } from 'features/saved-views/paths'
import { SOURCE_INTEGRATIONS_LABEL } from 'features/settings/nav-config'
import {
  CONNECTOR_LIBRARY_URL,
  CONNECTORS_URL,
  SETTINGS_URL,
  SOURCE_INTEGRATIONS_URL,
} from 'features/settings/paths'
import { SOURCE_UPLOAD_URL } from 'features/source-upload/paths'
import { AGENTS_URL, TREND_DETECTION_URL } from 'features/trend-detection/paths'
import { WIKI_URL } from 'features/wiki/paths'
import { PRODUCTS_URL, SOURCES_URL } from 'routes/detection'
import { DASHBOARDS_2_1_URL } from 'src/features/dashboards-v2-1/paths'
import { DASHBOARDS_2_URL } from 'src/features/dashboards-v2/paths'

/**
 * Route key → human-readable display name.
 * Used for breadcrumbs in ProjectLayout and for the NavAnnotationPreview panel.
 */
export const routeNameMap: Record<string, string> = {
  [DASHBOARD_URL]: 'Dashboards',
  [DASHBOARDS_2_URL]: 'Dashboards',
  [DASHBOARDS_2_1_URL]: 'Dashboards 2.1',
  [CHARTS_URL]: 'Charts',
  [CHARTS_2_URL]: 'Charts',
  [FEEDBACK_URL]: 'Feedback',
  [CATALOG_URL]: 'Catalog',
  [PDP_URL]: 'PDP Insights',
  [SOURCES_URL]: 'Sources',
  [PRODUCTS_URL]: 'Products',
  [SETTINGS_URL]: 'Settings',
  [CONNECTORS_URL]: 'Connectors',
  [CONNECTOR_LIBRARY_URL]: 'Data connections',
  [SOURCE_INTEGRATIONS_URL]: SOURCE_INTEGRATIONS_LABEL,
  [SOURCE_UPLOAD_URL]: 'Source Upload',
  [COVERAGE_URL]: 'Coverage',
  [RECOMMENDATIONS_URL]: 'Recommendations',
  [PRODUCT_WATCH_URL]: 'Product Watch',
  [KEYWORDS_URL]: 'Keywords',
  [SAVED_VIEWS_URL]: 'Saved',
  [ALERTS_URL]: 'Alerts',
  [ASK_YOGI_URL]: 'Ask Yogi',
  [TREND_DETECTION_URL]: 'Insights',
  [AGENTS_URL]: 'Agents',
  [WIKI_URL]: 'Wiki',
}
